import React from 'react';
import { Badge, Box, Tooltip, Group } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import type { EntityRegistryEntry } from '../types';
import { getWorkflowWarnings } from '../../validation/workflowValidation';

export const workflowConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'Type'],
    editor: 'workflowDesigner',
    listColumns: () => [
        {
            key: 'type',
            label: 'Type',
            sortable: false,
            render: (entity: any) => {
                const type = (entity.Type || '').toString().trim();
                if (!type) return '';
                const colorMap: Record<string, string> = { Action: 'orange', Authorization: 'blue', Request: 'violet' };
                const color = colorMap[type];
                if (color) return <Badge variant="light" size="sm" color={color}>{type}</Badge>;
                return (
                    <Group gap={4} align="center">
                        <Badge variant="light" size="sm" color="red">{type}</Badge>
                        <Tooltip label={`Invalid Type: "${type}". Must be Action, Authorization, or Request`}>
                            <Box component="span" display="inline-flex">
                                <IconAlertCircle size={18} color="var(--mantine-color-red-6)" />
                            </Box>
                        </Tooltip>
                    </Group>
                );
            }
        }
    ],
    detailTabs: { showStepsTab: true },
    getWarnings: (data) => getWorkflowWarnings(data),
};
